import React from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { FileDown, Construction } from 'lucide-react';

export const AbschriftenExport = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold" style={{fontFamily: 'Manrope, sans-serif'}}>
            Export-Abschriften
          </h1>
          <p className="text-muted-foreground mt-2">
            Abschriften als PDF oder Excel exportieren
          </p>
        </div>

        <Card className="border-2 border-dashed border-green-300">
          <CardContent className="py-16 text-center">
            <div className="flex justify-center mb-4">
              <div className="p-4 bg-green-100 rounded-full">
                <Construction className="h-12 w-12 text-green-600" />
              </div>
            </div>
            <CardTitle className="text-xl mb-2">In Entwicklung</CardTitle>
            <CardDescription className="max-w-md mx-auto">
              Hier können Sie bald Abschriften exportieren. 
              Erstellen Sie PDF-Reports für Ihre Dokumentation.
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};
